import { ContainerAccessors, ContainerTypeEnum } from '../../Container';
import { ItemDerivers, ItemValidators } from '../../Item';
import { RuleDataAccessors } from '../../RuleData';
/**
 *
 * @param currencies
 * @param preferences
 * @param ruleData
 */
export function generateCoinWeight(currencies, preferences, ruleData) {
    let weight = 0;
    if (currencies === null) {
        return weight;
    }
    if (preferences !== null && !preferences.ignoreCoinWeight) {
        RuleDataAccessors.getCurrencyData(ruleData).forEach((currencyInfo) => {
            if (currencyInfo.name !== null) {
                const heldCurrencyAmount = currencies[currencyInfo.name.toLowerCase()];
                if (heldCurrencyAmount) {
                    weight += currencyInfo.weight * heldCurrencyAmount;
                }
            }
        });
    }
    return weight;
}
/**
 *
 * @param allItems
 * @param customItems
 * @returns {number}
 */
export function generateItemWeight(allItems, customItems) {
    return ItemDerivers.deriveItemsWeightTotal(allItems) + ItemDerivers.deriveItemsWeightTotal(customItems);
}
/**
 *
 * @param characterContainers
 * @returns {number}
 */
export function generateContainerItemWeight(characterContainers, partyContainers, characterId) {
    return [...characterContainers, ...partyContainers].reduce((acc, container) => {
        const type = ContainerAccessors.getContainerType(container);
        const isEquipped = ContainerAccessors.isEquipped(container);
        if (type === ContainerTypeEnum.ITEM && isEquipped) {
            const containerItem = ContainerAccessors.getItem(container);
            if (containerItem && ItemValidators.isEquippedToCurrentCharacter(containerItem, characterId)) {
                const appliedWeight = ContainerAccessors.getWeightInfo(container).applied;
                acc += appliedWeight;
            }
        }
        if (type === ContainerTypeEnum.CHARACTER || type === ContainerTypeEnum.CAMPAIGN) {
            const appliedWeight = ContainerAccessors.getWeightInfo(container).applied;
            acc += appliedWeight;
        }
        return acc;
    }, 0);
}
/**
 * //TODO could include suppliers data
 * @param itemWeight
 * @param coinWeight
 */
export function generateTotalWeight(itemWeight, coinWeight) {
    return itemWeight + coinWeight;
}
